module.exports = __webpack_public_path__ + "static/media/thumbnail.dce0b1c0.jpg";